import * as React from 'react';
import { useIntl } from 'react-intl';
import * as EmployeeService from './EmployeeService';
import ConfirmDialog from '../ConfirmDialog';
import { IEmployeeConfrimDialog } from './interfaces';
import LoaderService from '../../Services/LoaderService';

function ActivateUser(props: IEmployeeConfrimDialog): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isContinueActionationButtonDisabled, setIsContinueActionationButtonDisabled] =
    React.useState(false);

  const closeConfirmDialog = () => {
    props.handleConfirmDialogOpen(false);
  };

  const handleSubmitMultipleActivateConfirmDialog = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    LoaderService.showLoader();
    const res = await EmployeeService.activateMultiple(props.selectedIds);
    if (res) {
      props.updateTable();
      props.handleConfirmDialogOpen(false);
    }
    LoaderService.showLoader(false);
  };

  const handleSubmitActivateConfirmDialog = async (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.preventDefault();
    setIsContinueActionationButtonDisabled(true);
    LoaderService.showLoader();

    const res = await EmployeeService.activate(props.selectedIds[0]);
    if (res) {
      props.updateTable();
      props.handleConfirmDialogOpen(false);
    }
    LoaderService.showLoader(false);
    setIsContinueActionationButtonDisabled(false);
  };

  return props.selectedIds.length > 1 ? (
    <ConfirmDialog
      title={`${f({ id: 'employee.actions.modal.title' })}`}
      cancelCallback={closeConfirmDialog}
      continueCallback={handleSubmitMultipleActivateConfirmDialog}
      cancelButtonTitle={f({
        id: 'form.cancel',
      })}
      continueButtonTitle={f({
        id: 'forgotPassword.send',
      })}
    >
      {f(
        { id: 'table.confirm.dialog.multiple.activate.message' },
        { count: props.selectedIds.length }
      )}
    </ConfirmDialog>
  ) : (
    <ConfirmDialog
      title={`${f({ id: 'employee.actions.modal.title' })}`}
      cancelCallback={closeConfirmDialog}
      continueCallback={handleSubmitActivateConfirmDialog}
      cancelButtonTitle={f({
        id: 'form.cancel',
      })}
      continueButtonTitle={f({
        id: 'forgotPassword.send',
      })}
      disableContinueButton={isContinueActionationButtonDisabled}
    >
      {f({ id: 'table.confirm.dialog.activate.message' }, { email: props.email })}
    </ConfirmDialog>
  );
}

export default ActivateUser;
